export const colorFades = {
  purple: {
    dark: {
      hex: '#160847',
      rgba: (a) => `rgba(22,8,71,${a})`,
    },
    lowDark: '#27195E',
    base: {
      hex: '#3F3175',
      hex2: '#5F5291',
      rgba: (a) => `rgba(63,49,117, ${a})`,
    },
    belowBase: '#5C4F8B',
    low: {
      hex: '#7E75A2',
      rgba: (a) => `rgba(126, 117, 162, ${a})`,
    },
    skillBorder: '1px solid rgba(255,255,255, 0.4)',
  },
  red: {
    dark: {
      hex: '#280003',
      rgba: (a) => `rgba(40,0,3,${a})`,
    },
    lowDark: '#3D0004',
    base: {
      hex: '#670008',
      hex2: '#B1343D',
      rgba: (a) => `rgba(103,0,8,${a})`,
    },
    belowBase: '#920812',
    low: {
      hex: '#B70817',
      rgba: (a) => `rgba(183, 8, 23,${a})`,
    },
    skillBorder: '1px solid rgba(255,255,255, 0.4)',
  },
  pink: {
    dark: {
      hex: '#530036',
      rgba: (a) => `rgba(83,0,54,${a})`,
    },
    lowDark: '#700049',
    base: {
      hex: '#87085B',
      hex2: '#B43A89',
      rgba: (a) => `rgba(135,8,91,${a})`,
    },
    belowBase: '#A31672',
    low: {
      hex: '#AF3885',
      rgba: (a) => `rgba(175, 56, 133,${a})`,
    },
    skillBorder: '1px solid rgba(255,255,255, 0.4)',
  },
  paleBlue: {
    dark: {
      hex: '#01859D',
      rgba: (a) => `rgba(1,133,157,${a})`,
    },
    lowDark: '#02C7EC',
    base: {
      hex: '#0FCBEE',
      hex2: '#68DBF1',
      rgba: (a) => `rgba(15,203,238,${a})`,
    },
    belowBase: '#3DD1ED',
    low: {
      hex: '#6DD9ED',
      rgba: (a) => `rgba(109, 217, 237,${a})`,
    },
    skillBorder: '1px solid rgba(0, 38, 35, 0.2)',
  },
  navyBlue: {
    dark: { hex: '#10054A', rgba: (a) => `rgba(16,5,74,${a})` },
    lowDark: '#190B64',
    base: {
      hex: '#251679',
      hex2: '#5142A1',
      rgba: (a) => `rgba(37,22,121,${a})`,
    },
    belowBase: '#352493',
    low: {
      hex: '#4E409D',
      rgba: (a) => `rgba(78, 64, 157,${a})`,
    },
    skillBorder: '1px solid rgba(255,255,255, 0.4)',
  },
  neon: {
    dark: {
      hex: '#002623',
      rgba: (a) => `rgba(0,38,35,${a})`,
    },
    lowDark: '#00413C',
    base: {
      hex: '#055D56',
      hex2: '#29827B',
      rgba: (a) => `rgba(5,93,86,${a})`,
    },
    belowBase: '#07726A',
    low: {
      hex: '#019086',
      rgba: (a) => `rgba(1, 144, 134,${a})`,
    },
    skillBorder: '1px solid rgba(0, 38, 35, 0.2)',
  },
  green: {
    dark: { hex: '#002E0E', rgba: (a) => `rgba(0,46,14,${a})` },
    lowDark: '#004E18',
    base: {
      hex: '#066F26',
      hex2: '#319C51',
      rgba: (a) => `rgba(6,111,38,${a})`,
    },
    belowBase: '#088A2F',
    low: {
      hex: '#01AD35',
      rgba: (a) => `rgba(1, 173, 53,${a})`,
    },
    skillBorder: '1px solid rgba(0, 38, 35, 0.2)',
  },
  orange: {
    dark: { hex: '#B16105', rgba: (a) => `rgba(177,97,5,${a})` },
    lowDark: '#EC830B',
    base: {
      hex: '#FFA43B',
      hex2: '#FFC889',
      rgba: (a) => `rgba(255,164,59,${a})`,
    },
    belowBase: '#FFB55F',
    low: {
      hex: '#FFC889',
      rgba: (a) => `rgba(255, 200, 137,${a})`,
    },
    skillBorder: '1px solid rgba(0, 38, 35, 0.2)',
  },
  darkOrange: {
    dark: { hex: '#3E1B00', rgba: (a) => `rgba(62,27,0,${a})` },
    lowDark: '#692E00',
    base: {
      hex: '#974608',
      hex2: '#D48142',
      rgba: (a) => `rgba(151,70,8,${a})`,
    },
    belowBase: '#BA570B',
    low: {
      hex: '#EB6702',
      rgba: (a) => `rgba(235, 103, 2, ${a})`,
    },
    skillBorder: '1px solid rgba(0, 38, 35, 0.2)',
  },
  grey: {
    dark: { hex: '#040303', rgba: (a) => `rgba(4,3,3,${a})` },
    lowDark: '#121212',
    base: {
      hex: '#4F4F4F',
      hex2: '#B1B0B0',
      rgba: (a) => `rgba(79,79,79,${a})`,
    },
    belowBase: '#7E7E7E',
    low: {
      hex: '#ABAAAA',
      rgba: (a) => `rgba(171, 170, 170,${a})`,
    },
    skillBorder: '1px solid rgba(0, 38, 35, 0.2)',
  },
  white: {
    dark: { hex: '#000', rgba: (a) => `rgba(167,166,166,${a})` },
    lowDark: '#D1D1D1',
    base: {
      hex: '#FFFFFF',
      hex2: '#FFFFFF',
      rgba: (a) => `rgba(255,255,255,${a})`,
    },
    belowBase: '#FFFFFF',
    low: {
      hex: '#ffffff',
      rgba: (a) => `rgba(255, 255, 255, ${a})`,
    },
    skillBorder: '1px solid rgba(0, 38, 35, 0.2)',
    black: '#000000',
  },
  brightOrange: {
    dark: { hex: '#8C2800', rgba: (a) => `rgba(140,40,0,${a})` },
    lowDark: '#B03200',
    base: {
      hex: '#D44208',
      hex2: '#F2632b',
      rgba: (a) => `rgba(212,66,8,${a})`,
    },
    belowBase: '#F2632B',
    low: {
      hex: '#FE8758',
      rgba: (a) => `rgba(254, 135, 88,${a})`,
    },
    skillBorder: '1px solid rgba(0, 38, 35, 0.2)',
  },
};

const commonAttractiveStyles = (theme, personalInfoText, restFont) => ({
  pane: colorFades[theme].base,
  paneHeadingBackgroundBox: colorFades[theme].dark,
  fontsPaneHeading: 'white',
  careerObjective: '#000',
  personalInfoText,
  restFont,
  centerText: '#000',
  centerHeadingBorder: 'thin solid rgba(46, 53, 62, 0.3);',
  boxShadow: '2px 2px 4px rgba(0,0,0,0.25)',
  rating: '#E5E5E5',
  covid19BadgeBG: `${theme === 'white' ? '#d9d9d9' : '#fff'}`,
  iconFill:
    theme === 'white' || theme === 'orange' ? 'rgba(51,51,51,0.87)' : 'white',
});

const commonVintageStyles = (theme) => ({
  sectionHeadingFont:
    theme !== 'white' ? colorFades[theme].base.hex : colorFades[theme].black,
  // theme !== 'white' ? colorFades[theme].base.hex : colorFades[theme].dark.hex,
  restFont: '#000',
  descriptionFont: '#000',
  borderBottom: 'thin solid rgba(46, 53, 62, 0.3)',
  iconFill:
    theme !== 'white' ? colorFades[theme].base.hex : colorFades[theme].black,
  sectionHeadingBg: theme !== 'white' ? '#eeeeeede' : '#ece9e1',
});
const commonAgriculturalStyles = (theme) => ({
  sectionHeadingFont:
    theme !== 'white' ? colorFades[theme].base.hex : colorFades[theme].dark.hex,
  restFont: '#000',
  descriptionFont: '#000',
  borderBottom: '0.7px  solid #000000',
  iconFill:
    theme !== 'white' ? colorFades[theme].base.hex : colorFades[theme].dark.hex,
});

const commonNinetiesStyles = (theme) => ({
  sectionHeadingFont:
    theme !== 'white' ? colorFades[theme].base.hex : 'rgba(46, 53, 62, 0.87)',
  sectionHeadingFontRGB:
    theme !== 'white'
      ? colorFades[theme].base.rgba(0.4)
      : 'rgba(46, 53, 62, 0.4)',
  paneHeadingBackgroundBox: 'rgba(244, 244, 244, 0.87)',
  restFont: '#000',
  descriptionFont: '#000',
  borderBottom: 'thin solid rgba(46, 53, 62, 0.3)',
  ratingSelected: colorFades[theme].dark.hex,
  ratingUnselected: `rgba(22, 8, 71,0.2)`,
  pane: colorFades[theme].base.rgba(0.2),
  iconFill:
    theme !== 'white' ? colorFades[theme].base.hex : colorFades[theme].dark.hex,
});
const newLocal = (theme) =>
  theme !== 'white' ? colorFades[theme].dark.hex : colorFades[theme].black;
const commonElegantStyles = (
  theme,
  rightPaneBackgroundOpacity,
  restFont,
  rightPaneHeading,
  personalInfoSubHeadingFont,
  themeType,
  ratingUnselected,
  topPaneFont,
  skillBorderOpacity,
) => ({
  topPaneBackground: colorFades[theme].base.hex,
  topPaneBackgroundRGBA: colorFades[theme].base.rgba(skillBorderOpacity),
  topPaneFont,
  restFont,
  personalLinkBackground: restFont,
  rightPaneBackground: () =>
    colorFades[theme].base.rgba(rightPaneBackgroundOpacity),
  personalInfoFont: restFont,
  personalInfoSubHeadingFont,
  rightPaneHeading,
  ratingSelected:
    themeType === 'lightTheme'
      ? colorFades[theme].dark.hex
      : colorFades[theme].base.hex,
  ratingUnselected,
  centerFont: '#000',
  centerFontLight: '#000',
  sectionHeadingFont:
    themeType === 'lightTheme' ? newLocal(theme) : colorFades[theme].base.hex,
  sectionHeadingFontRGB:
    themeType === 'lightTheme'
      ? colorFades[theme].dark.rgba(0.4)
      : colorFades[theme].base.rgba(0.4),
  boxShadow: theme === 'white' ? 'none' : '2px 0 4px rgba(0,0,0,0.25)',
  borderBottom: 'thin solid rgba(46, 53, 62, 0.5)',
  stroke: colorFades[theme].base,
  covid19BadgeBG: `${theme === 'white' ? '#d9d9d9' : '#fff'}`,
  iconFill:
    theme === 'white' || theme === 'orange' ? 'rgba(51,51,51,0.87)' : 'white',
  skillBorderColor: colorFades[theme].skillBorder,
});

const commonGradientStyles = (color) => ({
  ...commonVintageStyles(color),
  sectionHeadingFont: 'rgba(46, 53, 62, 0.65)',
  iconFillGrad:
    color !== 'white'
      ? { dark: colorFades[color].base.hex, light: colorFades[color].base.hex2 }
      : { dark: colorFades[color].dark.hex, light: colorFades[color].dark.hex },
});
const elegantStyles = {
  purple: commonElegantStyles(
    'purple',
    '0.6',
    'white',
    'white',
    'rgba(255,255,255,0.87)',
    'darkTheme',
    colorFades.purple.dark.rgba(0.2),
    'white',
    '0.3',
  ),
  red: commonElegantStyles(
    'red',
    '0.6',
    'white',
    'white',
    'rgba(255,255,255,0.87)',
    'darkTheme',
    colorFades.red.dark.rgba(0.2),
    'white',
    '0.3',
  ),
  pink: commonElegantStyles(
    'pink',
    '0.6',
    'white',
    'white',
    'rgba(255,255,255,0.87)',
    'darkTheme',
    colorFades.pink.dark.rgba(0.2),
    'white',
    '0.3',
  ),
  paleBlue: commonElegantStyles(
    'paleBlue',
    '0.6',
    '#000',
    '#000',
    '#000',
    'lightTheme',
    colorFades.paleBlue.dark.rgba(0.2),
    'white',
    '0.3',
  ),
  navyBlue: commonElegantStyles(
    'navyBlue',
    '0.6',
    'white',
    'white',
    'rgba(255,255,255,0.87)',
    'darkTheme',
    colorFades.navyBlue.dark.rgba(0.2),
    'white',
    '0.3',
  ),
  neon: commonElegantStyles(
    'neon',
    '0.2',
    '#000',
    colorFades.neon.dark.hex,
    '#000',
    'lightTheme',
    colorFades.neon.dark.rgba(0.2),
    'white',
    '0.2',
  ),
  green: commonElegantStyles(
    'green',
    '0.2',
    '#000',
    colorFades.green.dark.hex,
    '#000',
    'lightTheme',
    colorFades.green.dark.rgba(0.2),
    'white',
    '0.2',
  ),
  orange: commonElegantStyles(
    'orange',
    '0.5',
    '#000',
    colorFades.orange.dark.hex,
    '#000',
    'lightTheme',
    colorFades.orange.dark.rgba(0.2),
    'white',
    '0.3',
  ),
  darkOrange: commonElegantStyles(
    'darkOrange',
    '0.3',
    '#000',
    colorFades.darkOrange.dark.hex,
    '#000',
    'darkTheme',
    colorFades.darkOrange.dark.rgba(0.2),
    'white',
    '0.3',
  ),
  grey: commonElegantStyles(
    'grey',
    '0.2',
    '#000',
    colorFades.grey.dark.hex,
    '#000',
    'lightTheme',
    colorFades.grey.dark.rgba(0.2),
    'white',
    '0.2',
  ),
  white: commonElegantStyles(
    'white',
    '0.15',
    '#000',
    colorFades.white.black,
    '#000',
    'lightTheme',
    colorFades.white.dark.rgba(0.5),
    '#000',
    '0.3',
  ),
  brightOrange: commonElegantStyles(
    'brightOrange',
    '0.15',
    '#000',
    colorFades.brightOrange.base.hex,
    '#000',
    'darkTheme',
    colorFades.brightOrange.dark.rgba(0.2),
    'white',
    '0.3',
  ),
};

export default {
  attractive: {
    purple: commonAttractiveStyles('purple', '#FFFFFF', '#FFFFFF'),
    red: commonAttractiveStyles('red', '#FFFFFF', '#FFFFFF'),
    pink: commonAttractiveStyles('pink', '#FFFFFF', '#FFFFFF'),
    paleBlue: commonAttractiveStyles('paleBlue', '#000', '#000'),
    navyBlue: commonAttractiveStyles('navyBlue', '#FFFFFF', '#FFFFFF'),
    neon: commonAttractiveStyles('neon', '#FFFFFF', '#FFFFFF'),
    green: commonAttractiveStyles('green', '#FFFFFF', '#FFFFFF'),
    orange: commonAttractiveStyles('orange', '#000', '#000'),
    darkOrange: commonAttractiveStyles('darkOrange', '#FFFFFF', '#FFFFFF'),
    grey: commonAttractiveStyles('grey', '#FFFFFF', '#FFFFFF'),
    white: commonAttractiveStyles('white', '#000', '#000'),
    brightOrange: commonAttractiveStyles('brightOrange', '#FFFFFF', '#FFFFFF'),
  },
  vintage: {
    purple: commonVintageStyles('purple'),
    red: commonVintageStyles('red'),
    pink: commonVintageStyles('pink'),
    paleBlue: commonVintageStyles('paleBlue'),
    navyBlue: commonVintageStyles('navyBlue'),
    neon: commonVintageStyles('neon'),
    green: commonVintageStyles('green'),
    orange: commonVintageStyles('orange'),
    darkOrange: commonVintageStyles('darkOrange'),
    grey: commonVintageStyles('grey'),
    white: commonVintageStyles('white'),
    brightOrange: commonVintageStyles('brightOrange'),
  },
  basic: {
    purple: commonVintageStyles('purple'),
    red: commonVintageStyles('red'),
    pink: commonVintageStyles('pink'),
    paleBlue: commonVintageStyles('paleBlue'),
    navyBlue: commonVintageStyles('navyBlue'),
    neon: commonVintageStyles('neon'),
    green: commonVintageStyles('green'),
    orange: commonVintageStyles('orange'),
    darkOrange: commonVintageStyles('darkOrange'),
    grey: commonVintageStyles('grey'),
    white: commonVintageStyles('white'),
    brightOrange: commonVintageStyles('brightOrange'),
  },
  gradient: {
    purple: commonGradientStyles('purple'),
    red: commonGradientStyles('red'),
    pink: commonGradientStyles('pink'),
    paleBlue: commonGradientStyles('paleBlue'),
    navyBlue: commonGradientStyles('navyBlue'),
    neon: commonGradientStyles('neon'),
    green: commonGradientStyles('green'),
    orange: commonGradientStyles('orange'),
    darkOrange: commonGradientStyles('darkOrange'),
    grey: commonGradientStyles('grey'),
    white: commonGradientStyles('white'),
    brightOrange: commonGradientStyles('brightOrange'),
  },
  streak: {
    purple: commonGradientStyles('purple'),
    red: commonGradientStyles('red'),
    pink: commonGradientStyles('pink'),
    paleBlue: commonGradientStyles('paleBlue'),
    navyBlue: commonGradientStyles('navyBlue'),
    neon: commonGradientStyles('neon'),
    green: commonGradientStyles('green'),
    orange: commonGradientStyles('orange'),
    darkOrange: commonGradientStyles('darkOrange'),
    grey: commonGradientStyles('grey'),
    white: commonGradientStyles('white'),
    brightOrange: commonGradientStyles('brightOrange'),
  },
  proxima: {
    purple: commonGradientStyles('purple'),
    red: commonGradientStyles('red'),
    pink: commonGradientStyles('pink'),
    paleBlue: commonGradientStyles('paleBlue'),
    navyBlue: commonGradientStyles('navyBlue'),
    neon: commonGradientStyles('neon'),
    green: commonGradientStyles('green'),
    orange: commonGradientStyles('orange'),
    darkOrange: commonGradientStyles('darkOrange'),
    grey: commonGradientStyles('grey'),
    white: commonGradientStyles('white'),
    brightOrange: commonGradientStyles('brightOrange'),
  },
  techie: {
    purple: commonGradientStyles('purple'),
    red: commonGradientStyles('red'),
    pink: commonGradientStyles('pink'),
    paleBlue: commonGradientStyles('paleBlue'),
    navyBlue: commonGradientStyles('navyBlue'),
    neon: commonGradientStyles('neon'),
    green: commonGradientStyles('green'),
    orange: commonGradientStyles('orange'),
    darkOrange: commonGradientStyles('darkOrange'),
    grey: commonGradientStyles('grey'),
    white: commonGradientStyles('white'),
    brightOrange: commonGradientStyles('brightOrange'),
  },
  falcon: {
    purple: commonGradientStyles('purple'),
    red: commonGradientStyles('red'),
    pink: commonGradientStyles('pink'),
    paleBlue: commonGradientStyles('paleBlue'),
    navyBlue: commonGradientStyles('navyBlue'),
    neon: commonGradientStyles('neon'),
    green: commonGradientStyles('green'),
    orange: commonGradientStyles('orange'),
    darkOrange: commonGradientStyles('darkOrange'),
    grey: commonGradientStyles('grey'),
    white: commonGradientStyles('white'),
    brightOrange: commonGradientStyles('brightOrange'),
  },
  orion: {
    purple: commonGradientStyles('purple'),
    red: commonGradientStyles('red'),
    pink: commonGradientStyles('pink'),
    paleBlue: commonGradientStyles('paleBlue'),
    navyBlue: commonGradientStyles('navyBlue'),
    neon: commonGradientStyles('neon'),
    green: commonGradientStyles('green'),
    orange: commonGradientStyles('orange'),
    darkOrange: commonGradientStyles('darkOrange'),
    grey: commonGradientStyles('grey'),
    white: commonGradientStyles('white'),
    brightOrange: commonGradientStyles('brightOrange'),
  },
  nineties: {
    purple: commonNinetiesStyles('purple'),
    red: commonNinetiesStyles('red'),
    pink: commonNinetiesStyles('pink'),
    paleBlue: commonNinetiesStyles('paleBlue'),
    navyBlue: commonNinetiesStyles('navyBlue'),
    neon: commonNinetiesStyles('neon'),
    green: commonNinetiesStyles('green'),
    orange: commonNinetiesStyles('orange'),
    darkOrange: commonNinetiesStyles('darkOrange'),
    grey: commonNinetiesStyles('grey'),
    white: commonNinetiesStyles('white'),
    brightOrange: commonNinetiesStyles('brightOrange'),
  },
  inventor: {
    purple: commonNinetiesStyles('purple'),
    red: commonNinetiesStyles('red'),
    pink: commonNinetiesStyles('pink'),
    paleBlue: commonNinetiesStyles('paleBlue'),
    navyBlue: commonNinetiesStyles('navyBlue'),
    neon: commonNinetiesStyles('neon'),
    green: commonNinetiesStyles('green'),
    orange: commonNinetiesStyles('orange'),
    darkOrange: commonNinetiesStyles('darkOrange'),
    grey: commonNinetiesStyles('grey'),
    white: commonNinetiesStyles('white'),
    brightOrange: commonNinetiesStyles('brightOrange'),
  },
  simple: {
    purple: commonVintageStyles('purple'),
    red: commonVintageStyles('red'),
    pink: commonVintageStyles('pink'),
    paleBlue: commonVintageStyles('paleBlue'),
    navyBlue: commonVintageStyles('navyBlue'),
    neon: commonVintageStyles('neon'),
    green: commonVintageStyles('green'),
    orange: commonVintageStyles('orange'),
    darkOrange: commonVintageStyles('darkOrange'),
    grey: commonVintageStyles('grey'),
    white: commonVintageStyles('white'),
    brightOrange: commonVintageStyles('brightOrange'),
  },
  geospatial: {
    purple: commonVintageStyles('purple'),
    red: commonVintageStyles('red'),
    pink: commonVintageStyles('pink'),
    paleBlue: commonVintageStyles('paleBlue'),
    navyBlue: commonVintageStyles('navyBlue'),
    neon: commonVintageStyles('neon'),
    green: commonVintageStyles('green'),
    orange: commonVintageStyles('orange'),
    darkOrange: commonVintageStyles('darkOrange'),
    grey: commonVintageStyles('grey'),
    white: commonVintageStyles('white'),
    brightOrange: commonVintageStyles('brightOrange'),
  },
  functional: {
    purple: commonVintageStyles('purple'),
    red: commonVintageStyles('red'),
    pink: commonVintageStyles('pink'),
    paleBlue: commonVintageStyles('paleBlue'),
    navyBlue: commonVintageStyles('navyBlue'),
    neon: commonVintageStyles('neon'),
    green: commonVintageStyles('green'),
    orange: commonVintageStyles('orange'),
    darkOrange: commonVintageStyles('darkOrange'),
    grey: commonVintageStyles('grey'),
    white: commonVintageStyles('white'),
    brightOrange: commonVintageStyles('brightOrange'),
  },
  businessmajor: {
    purple: commonVintageStyles('purple'),
    red: commonVintageStyles('red'),
    pink: commonVintageStyles('pink'),
    paleBlue: commonVintageStyles('paleBlue'),
    navyBlue: commonVintageStyles('navyBlue'),
    neon: commonVintageStyles('neon'),
    green: commonVintageStyles('green'),
    orange: commonVintageStyles('orange'),
    darkOrange: commonVintageStyles('darkOrange'),
    grey: commonVintageStyles('grey'),
    white: commonVintageStyles('white'),
    brightOrange: commonVintageStyles('brightOrange'),
  },
  agricultural: {
    purple: commonAgriculturalStyles('purple'),
    red: commonAgriculturalStyles('red'),
    pink: commonAgriculturalStyles('pink'),
    paleBlue: commonAgriculturalStyles('paleBlue'),
    navyBlue: commonAgriculturalStyles('navyBlue'),
    neon: commonAgriculturalStyles('neon'),
    green: commonAgriculturalStyles('green'),
    orange: commonAgriculturalStyles('orange'),
    darkOrange: commonAgriculturalStyles('darkOrange'),
    grey: commonAgriculturalStyles('grey'),
    white: commonAgriculturalStyles('white'),
    brightOrange: commonAgriculturalStyles('brightOrange'),
  },
  stellar: {
    purple: commonVintageStyles('purple'),
    red: commonVintageStyles('red'),
    pink: commonVintageStyles('pink'),
    paleBlue: commonVintageStyles('paleBlue'),
    navyBlue: commonVintageStyles('navyBlue'),
    neon: commonVintageStyles('neon'),
    green: commonVintageStyles('green'),
    orange: commonVintageStyles('orange'),
    darkOrange: commonVintageStyles('darkOrange'),
    grey: commonVintageStyles('grey'),
    white: commonVintageStyles('white'),
    brightOrange: commonVintageStyles('brightOrange'),
  },
  emblem: {
    purple: commonVintageStyles('purple'),
    red: commonVintageStyles('red'),
    pink: commonVintageStyles('pink'),
    paleBlue: commonVintageStyles('paleBlue'),
    navyBlue: commonVintageStyles('navyBlue'),
    neon: commonVintageStyles('neon'),
    green: commonVintageStyles('green'),
    orange: commonVintageStyles('orange'),
    darkOrange: commonVintageStyles('darkOrange'),
    grey: commonVintageStyles('grey'),
    white: commonVintageStyles('white'),
    brightOrange: commonVintageStyles('brightOrange'),
  },
  elegant: { ...elegantStyles },
  exemplary: { ...elegantStyles },
  classic: {
    purple: commonVintageStyles('purple'),
    red: commonVintageStyles('red'),
    pink: commonVintageStyles('pink'),
    paleBlue: commonVintageStyles('paleBlue'),
    navyBlue: commonVintageStyles('navyBlue'),
    neon: commonVintageStyles('neon'),
    green: commonVintageStyles('green'),
    orange: commonVintageStyles('orange'),
    darkOrange: commonVintageStyles('darkOrange'),
    grey: commonVintageStyles('grey'),
    white: commonVintageStyles('white'),
    brightOrange: commonVintageStyles('brightOrange'),
  },
};
